import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
// import { deviceLayout } from 'styles/breakpoint'

export const StyledGeneralDesktopContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  padding: 0 16px;

  background-color: ${theme.colors.white};
`

export const StyledScrollListContainer = styled.div`
  ${MediaQueries.mbDown} {
    .gird-view > .container > .section {
      max-width: 295px;
    }
  }
`

export const StyledHeroContainer = styled.div`
  display: flex;
  max-width: 500px;
  align-self: stretch;
  justify-content: stretch;

  background-color: ${theme.colors.white};

  justify-self: stretch;

  & > div > div {
    height: 100%;
  }

  .banner {
    min-height: 312px;
  }
`

export const StyledArticleContainer = styled.div`
  background-color: ${theme.colors.white};

  .banner {
    width: 100%;
    min-height: 192px;
  }

  ${MediaQueries.mbUp} {
    padding: 24px 16px 24px 0;
  }

  ${MediaQueries.mbDown} {
    padding: 24px 0;
  }
`

export const StyledSubHeroContainer = styled.div`
  display: flex;
  justify-content: space-between;

  padding-top: 8px;
  background-color: ${theme.colors.white};

  .banner {
    min-height: 150px;
  }

  .content .new .text {
    margin: 6px 0;
  }
`

export const StyledArticleDesktopContainer = styled.div`
  ${MediaQueries.mbUp} {
    width: 50%;
    padding: 16px;
  }
  ${MediaQueries.mbDown} {
    padding: 8px;
  }

  background-color: ${theme.colors.white};
`
export const StyledTitleContainer = styled.div`
  ${MediaQueries.mbUp} {
    padding: 0 16px;
  }
`
